export default __webpack_public_path__ + "static/media/reenroll-fsa-checklist.81b22ec6.svg";